// PrivacyPolicy.jsx - Estatica Skin and Laser
import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import MyNavbar from "../../components/customer/myNavbar/MyNavbar";
import Footer from "../../components/customer/footer/Footer";
import "../../assets/css/components/legalpages/Legalpages.css";

const sections = [
  { id: "collect", title: "Information We Collect" },
  { id: "use", title: "How We Use Your Information" },
  { id: "share", title: "How We Share Your Information" },
  { id: "cookies", title: "Cookies & Tracking" },
  { id: "security", title: "Data Security" },
  { id: "retention", title: "Data Retention" },
  { id: "rights", title: "Your Rights & Choices" },
  { id: "children", title: "Children's Privacy" },
  { id: "changes", title: "Changes to This Policy" },
  { id: "contact", title: "Contact Us" },
];

const PrivacyPolicy = () => {
  // Page navigate hoke khulte hi top se open ho, neeche se nahi
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MyNavbar />
      <section className="es-legal-page">
        <Container>
          {/* Hero */}
          <div className="es-legal-hero">
            <p className="es-legal-label">Legal</p>
            <h1 className="es-legal-heading">Privacy Policy</h1>
            <div className="es-legal-accent" />
            <span className="es-legal-updated">
              Last updated: <span className="es-legal-fill">[7/23/2026]</span>
            </span>
          </div>

          <div className="es-legal-layout">
            <Row>
              {/* Sticky TOC sidebar */}
              <Col lg={3}>
                <div className="es-legal-sidebar">
                  <p className="es-legal-toc-title">On this page</p>
                  <ul className="es-legal-toc">
                    {sections.map((s, i) => (
                      <li key={s.id}>
                        <a href={`#${s.id}`}>
                          {i + 1}. {s.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>

              {/* Content */}
              <Col lg={9}>
                <div className="es-legal-content">
                  <p className="es-legal-intro">
                    Estetica Skin & Laser ("we", "us", "our") respects your
                    privacy. This Privacy Policy explains what personal
                    information we collect through our website, how we use and
                    protect it, and the choices available to you. By using our
                    platform, you agree to the collection and use of information
                    as described in this Privacy Policy.
                  </p>

                  {/* 1. Information We Collect */}
                  <div className="es-legal-section" id="collect">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">1</span> Information We
                      Collect
                    </h2>
                    <p className="es-legal-text">
                      We collect the following types of information:
                    </p>
                    <ul className="es-legal-list">
                      <li>
                        <strong>Account information:</strong> full name, email
                        address, phone number, and password when you register.
                      </li>
                      <li>
                        <strong>Booking information:</strong> appointment dates,
                        selected treatments or deals, and any notes you provide
                        when booking.
                      </li>
                      {/* <li>
                      <strong>Health-related information you choose to share:</strong>{" "}
                      details relevant to your treatment (e.g., skin concerns,
                      allergies, medical history) that you disclose to our staff for
                      safety purposes.
                    </li> */}
                      {/* <li>
                      <strong>Payment information:</strong> processed through our
                      payment partners; we do not store full card details on our
                      servers.
                    </li> */}
                      <li>
                        <strong>Technical information:</strong> IP address,
                        browser type, device information, and usage data
                        collected automatically when you use our website or app.
                      </li>
                    </ul>
                  </div>

                  {/* 2. How We Use Your Information */}
                  <div className="es-legal-section" id="use">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">2</span> How We Use Your
                      Information
                    </h2>
                    <ul className="es-legal-list">
                      <li>To create and manage your account.</li>
                      <li>
                        To process, confirm, reschedule, and manage your
                        appointments and deal claims.
                      </li>
                      <li>
                        To send notifications and updates related to your
                        appointments, deals, and account.
                      </li>
                      <li>
                        To improve the performance and functionality of our
                        website and platform.
                      </li>
                      <li>
                        To comply with applicable legal obligations and resolve
                        disputes where necessary.
                      </li>
                    </ul>
                  </div>

                  {/* 3. How We Share Your Information */}
                  <div className="es-legal-section" id="share">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">3</span> How We Share
                      Your Information
                    </h2>
                    <p className="es-legal-text">
                      We do not sell your personal information. We may share
                      limited information with:
                    </p>
                    <ul className="es-legal-list">
                      <li>
                        Our clinical and front-desk staff, solely to deliver
                        your treatment and manage your appointment.
                      </li>
                      <li>
                        Service providers who help us operate our platform
                        (e.g., hosting and other technical services required to
                        operate the platform.), under confidentiality
                        obligations.
                      </li>
                      <li>
                        Legal or regulatory authorities, where required by law
                        or to protect the rights, safety, or property of
                        Estetica Skin &amp; Laser or others.
                      </li>
                    </ul>
                  </div>

                  {/* 4. Cookies & Tracking */}
                  <div className="es-legal-section" id="cookies">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">4</span> Cookies &amp;
                      Tracking
                    </h2>
                    <p className="es-legal-text">
                      Our website may use cookies and similar browser
                      technologies to maintain login sessions, remember user
                      preferences, and support the functionality of the
                      platform. You can manage or disable cookies through your
                      browser settings; however, doing so may affect certain
                      website features.
                    </p>
                  </div>

                  {/* 5. Data Security */}
                  <div className="es-legal-section" id="security">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">5</span> Data Security
                    </h2>
                    <p className="es-legal-text">
                      We use reasonable administrative, technical, and physical
                      safeguards to protect your information from unauthorized
                      access, loss, or misuse. However, no method of
                      transmission or storage is 100% secure, and we cannot
                      guarantee absolute security.
                    </p>
                  </div>

                  {/* 6. Data Retention */}
                  <div className="es-legal-section" id="retention">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">6</span> Data Retention
                    </h2>
                    <p className="es-legal-text">
                      We retain your personal and booking information for as
                      long as your account is active, or as needed to provide
                      our Services, comply with legal obligations, resolve
                      disputes, and enforce our agreements. You may request
                      deletion of your account as described in Section 7 below.
                    </p>
                  </div>

                  {/* 7. Your Rights & Choices */}
                  <div className="es-legal-section" id="rights">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">7</span> Your Rights
                      &amp; Choices
                    </h2>
                    <p className="es-legal-text">You may, at any time:</p>
                    <ul className="es-legal-list">
                      <li>
                        Access and update your profile information directly from
                        your account settings.
                      </li>
                      <li>
                        Request a copy of the personal information we hold about
                        you.
                      </li>
                      <li>
                        "You may contact us to request correction or deletion of
                        your personal information, subject to applicable
                        requirements."
                      </li>
                      <li>
                        Opt out of promotional communications by using the
                        unsubscribe option or contacting us directly.
                      </li>
                    </ul>
                    <p className="es-legal-text">
                      To exercise any of these rights, please contact us using
                      the details in Section 10 below.
                    </p>
                  </div>

                  {/* 8. Children's Privacy */}
                  <div className="es-legal-section" id="children">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">8</span> Children's
                      Privacy
                    </h2>
                    <p className="es-legal-text">
                      Our Services are not directed at individuals under 18. We
                      do not knowingly collect personal information from minors
                      without parental or guardian consent. If you believe a
                      minor has provided us with personal information, please
                      contact us so we can remove it.
                    </p>
                  </div>

                  {/* 9. Changes to This Policy */}
                  <div className="es-legal-section" id="changes">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">9</span> Changes to This
                      Policy
                    </h2>
                    <p className="es-legal-text">
                      We may update this Privacy Policy from time to time. When
                      we do, we will revise the "Last updated" date above and,
                      for material changes, provide reasonable notice through
                      the website or app. We encourage you to review this page
                      periodically.
                    </p>
                  </div>

                  {/* 10. Contact */}
                  <div className="es-legal-section" id="contact">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">10</span> Contact Us
                    </h2>
                    <div className="es-legal-contact-box">
                      <p className="es-legal-contact-name">
                        Estetica Skin &amp; Laser
                      </p>

                      <div className="es-legal-contact-row">
                        <span className="es-legal-contact-icon">
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z" />
                            <circle cx="12" cy="10" r="3" />
                          </svg>
                        </span>
                        <span className="es-legal-fill">
                          22A, Block A, Satellite Town, Gujranwala
                        </span>
                      </div>

                      <div className="es-legal-contact-row">
                        <span className="es-legal-contact-icon">
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                            <polyline points="22,6 12,13 2,6" />
                          </svg>
                        </span>
                        <a href="mailto:info@esteticaskinlaser.com">
                          info@esteticaskinlaser.com
                        </a>
                      </div>

                      <div className="es-legal-contact-row">
                        <span className="es-legal-contact-icon">
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                          </svg>
                        </span>
                        <span className="es-legal-fill">+92 311 1133023</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
